module.exports = __webpack_public_path__ + "static/media/1014355.59f7a3b8.jpg";